import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstCvs: [],
		cvs: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		getCvsModel(state) {
			let cvs = { ...state.cvs }
			cvs.cvsabert = Utils.ParseToDate(cvs.cvsabert)
			if (cvs.cvsdesbloq) {
				cvs.cvsdesbloq = Utils.ParseToDate(cvs.cvsdesbloq)
			}
			return cvs
		},
	},
	mutations: {
		set(state, cvs) {
			state.cvs = cvs
			state.cvs.cvsabert = new Date(cvs.cvsabert).toLocaleString(navigator.language, {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
			})
			state.cvs.cvsdesbloq = new Date(cvs.cvsdesbloq).toLocaleString(navigator.language, {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
			})
			if (cvs) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cvs = null
		},
		setParamsDataTable(state, payload) {
			state.lstCvs = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store) {
			store.commit("initForm")
		},
		async find(store, { cvscliente, cvsbloq, cvsenderid }) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Customer/Blocks/Find/${cvscliente}/${cvsbloq}/${cvsenderid}`)
				.then(response => {
					let cvs = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", cvs)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			store.state.loading = false
		},
		save(store) {
			if (store.state.update) {
				return store.dispatch("update")
			}
			return store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Customer/Blocks/Insert", store.getters.getCvsModel)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/bloqueios")
					store.state.cvs = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Customer/Blocks/Update", store.getters.getCvsModel)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/bloqueios")
					store.state.cvs = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async findList({ dispatch }, cvscliente) {
			return await this._vm.$axios
				.get(`/Customer/Blocks/FindList/${cvscliente}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Customer/Blocks/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					store.state.lstCvs = []
					store.state.search = ""
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.state.loading = false
			return payload
		},
	},
}
